import styles from "./Markdown.module.css";
import { Box, Code, ScrollArea, Table, Text, Title } from "@mantine/core";
import type { ReactNode } from "react";
import type { Components } from "react-markdown";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const markdownComponents = {
  code: ({ children }: { children?: ReactNode }) => <Code>{children}</Code>,
  table: ({ children }: { children?: ReactNode }) => (
    <ScrollArea type="auto" my="xs">
      <Table withTableBorder withColumnBorders>
        {children}
      </Table>
    </ScrollArea>
  ),
  h2: ({ children }: { children?: ReactNode }) => (
    <Title order={2} mb="xs">
      {children}
    </Title>
  ),
  h3: ({ children }: { children?: ReactNode }) => (
    <Title order={3} mb="xs">
      {children}
    </Title>
  ),
  h4: ({ children }: { children?: ReactNode }) => (
    <Title order={4} mb="xs">
      {children}
    </Title>
  ),
  h5: ({ children }: { children?: ReactNode }) => (
    <Title order={5} mb="xs">
      {children}
    </Title>
  ),
  h6: ({ children }: { children?: ReactNode }) => (
    <Title order={6} mb="xs">
      {children}
    </Title>
  ),
  p: ({ children }: { children?: ReactNode }) => (
    <Text component="p" mb="md" size="sm" fw={500}>
      {children}
    </Text>
  ),
  strong: ({ children }: { children?: ReactNode }) => (
    <Text component="strong" size="sm" fw={600}>
      {children}
    </Text>
  ),
  thead: ({ children }: { children?: ReactNode }) => <Table.Thead>{children}</Table.Thead>,
  tbody: ({ children }: { children?: ReactNode }) => <Table.Tbody>{children}</Table.Tbody>,
  tr: ({ children }: { children?: ReactNode }) => <Table.Tr>{children}</Table.Tr>,
  th: ({ children }: { children?: ReactNode }) => <Table.Th>{children}</Table.Th>,
  td: ({ children }: { children?: ReactNode }) => <Table.Td>{children}</Table.Td>
};

export default function Markdown({ children, components = {} }: { children: string; components?: Components }) {
  return (
    <Box className={styles.markdown}>
      {/* singleTilde: false — remark-gfm v4 defaults to true, which treats ~text~ as strikethrough.
          LLM-generated content uses single tildes for scientific notation etc., not markdown. */}
      <ReactMarkdown
        remarkPlugins={[[remarkGfm, { singleTilde: false }]]}
        components={{ ...markdownComponents, ...components }}
      >
        {children}
      </ReactMarkdown>
    </Box>
  );
}
